module.exports = __webpack_public_path__ + "img/0Q3A2198_FoamcoreMatted.5b0f7f24.jpg";